var map = {
	"../pages/admin-clinic-details/admin-clinic-details.module": [
		578
	],
	"../pages/admin-clinic-switch/admin-clinic-switch.module": [
		392
	],
	"../pages/admin-clinics-add/admin-clinics-add.module": [
		580
	],
	"../pages/admin-clinics/admin-clinics.module": [
		583
	],
	"../pages/admin-doctors/admin-doctors.module": [
		582
	],
	"../pages/admin-medications/admin-medications.module": [
		585
	],
	"../pages/admin-prescription-update/admin-prescription-update.module": [
		587
	],
	"../pages/admin-prescriptions/admin-prescriptions.module": [
		590
	],
	"../pages/admin-studies/admin-studies.module": [
		596
	],
	"../pages/admin-users-add/admin-users-add.module": [
		598
	],
	"../pages/admin-users/admin-users.module": [
		600
	],
	"../pages/admin-utility/admin-utility.module": [
		602
	],
	"../pages/clinic-doctors/clinic-doctors.module": [
		606
	],
	"../pages/clinic-medications-add/clinic-medications-add.module": [
		613
	],
	"../pages/clinic-medications/clinic-medications.module": [
		608
	],
	"../pages/home/home.module": [
		611
	],
	"../pages/login/login.module": [
		614
	],
	"../pages/medications/medications.module": [
		616
	],
	"../pages/patient-add/patient-add.module": [
		617
	],
	"../pages/patient-details/patient-details.module": [
		618
	],
	"../pages/patient-medication/patient-medication.module": [
		620
	],
	"../pages/patient-upload/patient-upload.module": [
		619
	],
	"../pages/patients/patients.module": [
		621
	],
	"../pages/prescriptions/prescriptions.module": [
		622
	],
	"../pages/settings/settings.module": [
		624
	],
	"../pages/studies/studies.module": [
		625
	],
	"../pages/survey/survey.module": [
		627
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 391;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 391
// module chunks = 0